import React, { Component } from 'react';
import { Label, Input, FormText, FormGroup, Button, Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj, staticUrl } from '../../actions';
import Select from 'react-select';
import years from '../../utils/years.json';

class Lembranca extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: '',
            year: new Date().getFullYear(),
            years: years,
            turmasFiltro: [],
            turmas: [],
            turmasOptions: [],
            texto: '',
            paroco: '',
            sacramento: '',
            header: '',
            numPages: null,
            file: '',
            query: '',
            url: '/turmas/reports/lembrancas',
            filtro: [true]
        }
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };

    componentDidMount() {
        this.props.fetchObjs('/turmas', 1, 1000)
            .then(() => {
                let turmas = this.props.records;
                let turmasFiltro = [];
                turmas.map((element) => {
                    return turmasFiltro.push({
                        label: `${element.DESCRICAO} - ${element.ANO} - ${element.catequista.pessoaFisica.pessoa.NOME}`,
                        value: `${element.DESCRICAO} - ${element.ANO} - ${element.catequista.pessoaFisica.pessoa.NOME}`,
                        ...element
                    });
                });
                this.setState({ turmasOptions: turmasFiltro });
            });
    }

    filterTurmas = (inputValue) => {
        return this.state.turmasOptions.filter(i =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    }

    handleChangeTurma = (newValue, actionMeta) => {
        newValue = newValue ? newValue : {};
        this.setState({ turmasFiltro: newValue });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handlePrint = (query) => {
        window.open(`${staticUrl}${this.state.url}${query}`, "_self")
    }

    buscaDados(state) {
        let query = `?token=${localStorage.getItem('token')}`;
        query += `&year=${state.year}`;
        query += `&data=${state.data}`;
        query += `&sacramento=${state.sacramento}`;
        query += `&paroco=${state.paroco}`;
        if (state.turmasFiltro) {
            let turmas = [];
            state.turmasFiltro.map(element => {
                return turmas.push(element.ID);
            });
            query += `&turmas=${JSON.stringify(turmas)}`;
        }
        this.setState({ query, file: `${staticUrl}${this.state.url}${query}` });
        this.handlePrint(query);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                            <FormGroup row>
                                    <Col md="2">
                                        <Label htmlFor="text-input">Ano</Label>
                                    </Col>
                                    <Col xs="10">
                                        <Input
                                            type="select"
                                            name="year"
                                            value={this.state.year}
                                            onChange={this.handleChange}
                                            id="year">
                                            <option value="-1">Todos</option>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((year) => {
                                                        return (
                                                            <option key={year} value={year}>{year}</option>
                                                        )
                                                    }) : null
                                            }
                                        </Input>
                                        <FormText color="muted"></FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col md="2">
                                        <Label htmlFor="text-input">Data</Label>
                                    </Col>
                                    <Col xs="12" md="10">
                                        <Input
                                            name="data"
                                            value={this.state.data}
                                            onChange={this.handleChange}
                                            id="data"
                                            required
                                        />
                                        <FormText color="muted"></FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col md="2">
                                        <Label htmlFor="text-input">Sacramento</Label>
                                    </Col>
                                    <Col xs="12" md="10">
                                        <Input
                                            name="sacramento"
                                            value={this.state.sacramento}
                                            onChange={this.handleChange}
                                            id="sacramento"
                                            required
                                        />
                                        <FormText color="muted"></FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col md="2">
                                        <Label htmlFor="text-input">Pároco</Label>
                                    </Col>
                                    <Col xs="12" md="10">
                                        <Input
                                            name="paroco"
                                            value={this.state.paroco}
                                            onChange={this.handleChange}
                                            id="paroco"
                                            required
                                        />
                                        <FormText color="muted"></FormText>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col md="2">
                                        <Label htmlFor="text-input">Turmas</Label>
                                    </Col>
                                    <Col xs="12" md="10">
                                        <Select
                                            isMulti
                                            onChange={this.handleChangeTurma}
                                            options={this.state.turmasOptions}
                                            value={this.state.turmasFiltro}
                                        />
                                        <FormText color="muted"></FormText>
                                    </Col>
                                </FormGroup>
                                    <Button type="button" size="sm" color="primary" onClick={() => this.buscaDados(this.state)}>
                                        <i className="fa fa-download"></i> Download
                                    </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        records: state.obj.records ? state.obj.records : [],
        meta: state.obj.meta ? state.obj.meta : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj })(Lembranca);

